import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';
import { buildQueryParams } from '../../utils/object';

export const infestationApi = createApi({
  reducerPath: 'infestationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getInfestations: builder.query({
      query: ({ page, limit, search, crop_id, infestation_status } = {}) => ({
        url: 'infestation',
        params: buildQueryParams({ page, limit, search, crop_id, infestation_status }),
      }),
    }),

    getInfestationProbability: builder.mutation({
      query: ({ body }) => ({
        url: 'infestation/infestation-probability',
        method: 'POST',
        body,
      }),
    }),

    getInfestationLevelDetails: builder.query({
      query: (id) => `infestation/level-details/${id}`,
    }),

    addInfestation: builder.mutation({
      query: (formData) => ({
        url: 'infestation',
        method: 'POST',
        body: formData,
      }),
    }),

    updateInfestation: builder.mutation({
      query: ({ infestation_id, ...formData }) => ({
        url: `infestation/${infestation_id}`,
        method: 'PUT',
        body: formData,
      }),
    }),

    deleteInfestation: builder.mutation({
      query: ({ infestation_id }) => ({
        url: `infestation/delete/${infestation_id}`,
        method: 'DELETE',
      }),
    }),

    toggleInfestationStatus: builder.mutation({
      query: ({ infestation_id, infestation_status }) => ({
        url: `infestation/${infestation_id}`,
        method: 'PUT',
        body: { infestation_status },
      }),
    }),

    createInfestationLevelDetails: builder.mutation({
      query: (formData) => ({
        url: 'infestation/level-details',
        method: 'POST',
        body: formData,
        formData: true,
      }),
    }),

    getInfestationSymptoms: builder.query({
      query: (infestation_id) => `infestation/symptom/${infestation_id}`,
    }),

    addInfestationSymptom: builder.mutation({
      query: (data) => ({
        url: 'infestation/symptom',
        method: 'POST',
        body: data,
      }),
    }),

    updateInfestationSymptom: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `infestation/symptom/${id}`,
        method: 'PUT',
        body: data,
      }),
    }),
  }),
});

export const {
  useGetInfestationsQuery,
  useGetInfestationProbabilityMutation,
  useGetInfestationLevelDetailsQuery,
  useAddInfestationMutation,
  useUpdateInfestationMutation,
  useDeleteInfestationMutation,
  useToggleInfestationStatusMutation,
  useCreateInfestationLevelDetailsMutation,
  useGetInfestationSymptomsQuery,
  useAddInfestationSymptomMutation,
  useUpdateInfestationSymptomMutation,
} = infestationApi;
